<template>
  <v-dialog
    :value="value"
    max-width="900"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-toolbar dense flat color="primary" dark>
        <v-toolbar-title>
          Todas as zonas — Cadastrado × Apuração
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-4">
        <v-alert
          dense
          text
          :type="metaFiltrada ? 'warning' : 'info'"
          icon="mdi-information-outline"
          class="apuracao-aviso mb-3"
        >
          <template v-if="metaFiltrada">
            <strong>Apuração total do candidato</strong> — não restrita à meta selecionada.
            A conversão pode exceder 100% em zonas com poucos cadastros nesta meta.
          </template>
          <template v-else>
            Comparativo entre todo o cadastro da equipe e a apuração total do candidato.
          </template>
        </v-alert>
        <v-text-field
          v-model="busca"
          append-icon="mdi-magnify"
          label="Pesquisar zona"
          single-line
          hide-details
          dense
          class="mb-3"
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="zonas"
          :search="busca"
          :items-per-page="15"
          :footer-props="{ itemsPerPageOptions: [10, 15, 25, 50, -1] }"
          dense
          fixed-header
          height="55vh"
          no-data-text="Sem dados para exibir."
          class="zona-completa-table"
        >
          <template v-slot:item.posicao="{ item }">
            {{ item.posicao }}º
          </template>
          <template v-slot:item.valor="{ item }">
            {{ formatNumber(item.valor) }}
          </template>
          <template v-slot:item.percentual="{ item }">
            {{ item.percentual.toFixed(1) }}%
          </template>
          <template v-slot:item.realizado="{ item }">
            <span class="realizado">{{ formatNumber(item.realizado) }}</span>
          </template>
          <template v-slot:item.percentualRealizado="{ item }">
            <span class="realizado">
              {{ item.percentualRealizado.toFixed(1) }}%
            </span>
          </template>
          <template v-slot:item.percentualConversao="{ item }">
            <span class="conv">
              {{ item.valor > 0 ? item.percentualConversao.toFixed(1) + '%' : '—' }}
            </span>
          </template>
        </v-data-table>

        <div class="totais-resumo mt-3">
          <span><strong>Total cadastrado:</strong> {{ formatNumber(totalCadastrado) }}</span>
          <span><strong>Total apurado:</strong> {{ formatNumber(totalApuracao) }}</span>
          <span>
            <strong>Conversão geral:</strong>
            {{ totalCadastrado > 0 ? ((totalApuracao / totalCadastrado) * 100).toFixed(1) + '%' : '—' }}
          </span>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatNumber } from "../utils/formatters";

export default {
  name: "ZonaCompletaModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    zonas: {
      type: Array,
      default: () => [],
    },
    totalCadastrado: {
      type: Number,
      default: 0,
    },
    totalApuracao: {
      type: Number,
      default: 0,
    },
    metaFiltrada: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      busca: "",
      headers: [
        { text: "#", value: "posicao", align: "start", width: 60 },
        { text: "Zona", value: "nome", align: "start" },
        { text: "Cadastrado", value: "valor", align: "end" },
        { text: "% Cad.", value: "percentual", align: "end" },
        { text: "Realizado", value: "realizado", align: "end" },
        { text: "% Real.", value: "percentualRealizado", align: "end" },
        { text: "Conversão", value: "percentualConversao", align: "end" },
      ],
    };
  },
  watch: {
    value(novo) {
      if (!novo) {
        this.busca = "";
      }
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped>
.realizado {
  color: #2e7d32;
  font-weight: 500;
}

.conv {
  color: #6a1b9a;
  font-weight: 500;
}

.totais-resumo {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  padding: 10px 14px;
  background-color: #eceff1;
  border-radius: 8px;
  font-size: 0.9rem;
}

.zona-completa-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
}

.apuracao-aviso {
  font-size: 0.82rem;
}
</style>
